<template>
  <footer id="site-footer" role="contentinfo" itemscope="itemscope" itemtype="http://schema.org/WPFooter">
    <a href="#app" class="pagetop">▲ PAGETOP</a>
    <div class="footbox">
      <div class="footbox__meta">
        <figure><img src="/images/common/logo_w.webp" alt=""></figure>
        <dl>
          <dt>レイワスチール株式会社</dt>
          <dd>〒306-0608 茨城県坂東市幸神平41番4号 工業団地つくばハイテクパークいわい内</dd>
          <dd>TEL:0297-44-5302 / FAX:0297-44-5303</dd>
        </dl>
      </div>
      <ul class="footbox__nav">
        <li itemprop="name" v-for="item in list" :key="item.url">
          <a itemprop="url" :href="item.url">
            {{ item.name }}<svg width="11" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m6.143 9 4-4-4-4M10.143 5H1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
        </li>
      </ul>
      <small class="copy">&copy; {{ currentYear }} Reiwa Steel All rights reserved.</small>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
#site-footer{
  background: module.$normal;
  color: #d8d8d9;
  a{
    color: #d8d8d9;
  }
  .pagetop{
    display: block;
    text-align: center;
    padding: 16px 0;
    color: #FFF;
    background:  module.tone(module.$normal, 1);
    &:hover{
      background: module.tone(module.$normal, 1.2);
    }
  }
  .footbox{
    max-width: 1300px;
    margin: 0 auto;
    padding: 72px 40px;
    @include module.flex();
    flex-wrap: wrap;
    align-items: center;
    @media screen and (max-width: module.$tab){
      display: block;
    }
    @media screen and (max-width: module.$phone){
      padding-top: 40px;
      padding-bottom: 40px;
    }
    &__meta{
      width: 540px;
      margin: 0 0 32px;
      @media screen and (max-width: module.$tab){
        width: auto;
      }
      > figure{
        width: 200px;
        img{
          width: 100%;
        }
      }
      > dl{
        dt{
          font-size: 1.66rem;
          font-weight: 700;
          margin: 0 0 16px;
          padding: 0 0 16px;
          border-bottom: rgba(#FFF,.12) 1px solid;
          position: relative;
          &:before{
            content: '';
            width: 64px;
            height: 2px;
            background: module.$main;
            position: absolute;
            left: 0;
            bottom: -1px;
          }
        }
        dd{
          font-size: .96rem;
        }
      }
    }
    &__nav{
      width: calc(100% - 540px);
      padding: 0 0 0 5.6vw;
      margin: 0 0 0 -24px;
      @include module.flex();
      flex-wrap: wrap;
      justify-content: flex-start;
      @media screen and (max-width: module.$tab){
        width: auto;
        padding: 0;
      }
      li{
        width: 33.3%;
        padding: 0 0 0 24px;
        @media screen and (max-width: module.$tab){
          width: 25%;
        }
        @media screen and (max-width: module.$phone){
          width: 50%;
        }
        a{
          display: block;
          border-bottom: rgba(#FFF,.12) 1px solid;
          padding: 12px 0;
          padding-right: 24px;
          font-size: .92rem;
          position: relative;
          @media screen and (max-width: module.$tab){
            font-size: .88rem;
          }
          @media screen and (max-width: module.$phone){
            padding: 16px 0;
            font-size: .78rem;
          }
          svg{
            position: absolute;
            top: 50%;
            right: 6px;
            transform: translateY(-50%);
            opacity: .56;
          }
        }
      }
    }
  }
  .copy{
    width: 100%;
    display: block;
    font-size: .8rem;
    @media screen and (max-width: module.$tab){
      margin: 40px 0 0;
    }
  }
}
</style>

<script>
export default {
  props: {
    list: {
      type: Array,
      require: true,
    }
  },
	data() {
		return {
			currentYear: new Date().getFullYear()
		}
	}
}
</script>